import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { SnackService } from 'src/app/services/snack.service';
import { Observable, Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-base',
  template: ``,
  standalone: false
})
export class BaseComponent implements OnInit, OnDestroy {
  constructor(public store: Store,  public router: Router, public route: ActivatedRoute, public snackService: SnackService) { }

  ngOnInit() { }

  ngOnDestroy() { }
}
